import { setShowYourResults, setFilters } from '../actions/survey'
import { withTranslations } from '../decorators/with-translations'
import UserSettingsWidget from '../components/ui/user-settings-widget'
import { connect } from 'react-redux'
import { compose } from "redux"
import { withRouter } from 'react-router'

const mapStateToProps = ({ survey: { showYourResults, filters } }) => {
  return {
    showYourResults,
    filters
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetShowYourResults: (value) => {
      dispatch(setShowYourResults(value));
    },
    onSetFilters: filters => {
      dispatch(setFilters(filters))
    },
  };
};

export default compose(
  withRouter,
  withTranslations,
  connect(mapStateToProps, mapDispatchToProps)
)(UserSettingsWidget);


// WEBPACK FOOTER //
// ./src/containers/user-settings-widget.js